import {Card, Collapse, Flex, Space, Switch} from "antd";
import {providers, StorageProviderSettings} from "./StorageProvider";

export const StorageProviders = (props: {
    settings: StorageProviderSettings[],
    onChange: (settings: StorageProviderSettings[]) => void
}) => {
    return (
        <Flex vertical={true} gap={10}>
            {providers.map(provider => <Card
                    key={provider.name + props.settings.find(p => p.name == provider.name)?.enabled}
                    title={<Flex align={'center'} gap={10}>{provider.icon}{provider.name}</Flex>}
                    extra={
                        <Switch
                            checked={props.settings.find(p => p.name == provider.name)?.enabled}
                            onChange={(checked, e) => {
                                e.stopPropagation()
                                if (props.settings.find(s => s.name === provider.name)) {
                                    props.onChange(props.settings.map(s => s.name === provider.name ? {
                                        ...s,
                                        enabled: checked
                                    } : s))
                                } else {
                                    props.onChange(props.settings.concat({
                                        name: provider.name,
                                        enabled: checked,
                                        settings: {}
                                    }))
                                }
                            }}
                        />
                    }
                >
                    {
                        provider.settingComponent(
                            {
                                settings: props.settings.find(s => s.name === provider.name) || {
                                    name: provider.name,
                                    enabled: false,
                                    settings: {}
                                },
                                onChange: (settings: StorageProviderSettings) => {
                                    if (props.settings.find(s => settings.name === s.name)) {
                                        props.onChange(props.settings.map(s => s.name === settings.name ? settings : s))
                                    } else {
                                        props.onChange(props.settings.concat(settings))
                                    }
                                }
                            }
                        )
                    }
                </Card>
            )}
        </Flex>
    )
}